// SSO password validation
export const meetsLength = (password, length = 8) => password.length >= length;
export const containsNumber = password => /\d/.test(password);
export const containsSpecialCharacter = password => /[!@#$%^&*(),.?":{}|<>]/.test(password);
export const containsUppercase = password => /[A-Z]/.test(password);
export const containsLowercase = password => /[a-z]/.test(password);
